import { calculateAge, getPlayerRole } from '@shared/utils'
import Trans from 'next-translate/Trans'

// const getPlayerDOB = (p) => {
//   if (p?.dBirthDate && p?.sBirthPlace) {
//     return `${convertDt24h(p?.dBirthDate)}, ${p?.sBirthPlace}`
//   } else if (p?.dBirthDate && !p?.sBirthPlace) {
//     return convertDt24h(p?.dBirthDate)
//   } else if (!p?.dBirthDate && p?.sBirthPlace) {
//     return p?.sBirthPlace
//   } else return '--'
// }

export const preparePlayerInfoCompression = (p1, p2) => {
  const { years: p1Year, days: p1Days } = calculateAge(p1?.dBirthDate)
  const { years: p2Year, days: p2Days } = calculateAge(p2?.dBirthDate)
  return [
    {
      title: <Trans i18nKey="common:Age" />,
      val1: p1?.dBirthDate ? `${p1Year}y ${p1Days}d` : '--',
      val2: p2?.dBirthDate ? `${p2Year}y ${p2Days}d` : '--'
    },
    {
      title: <Trans i18nKey="common:Role" />,
      val1: getPlayerRole(p1?.sPlayingRole),
      val2: getPlayerRole(p2?.sPlayingRole)
    },
    {
      title: <Trans i18nKey="common:BattingStyle" />,
      val1: p1?.sBattingStyle,
      val2: p2?.sBattingStyle
    },
    {
      title: <Trans i18nKey="common:BowlingStyle" />,
      val1: p1?.sBowlingStyle,
      val2: p2?.sBowlingStyle
    }
  ]
}

const prepareBatData = (obj1, obj2) => {
  return [
    {
      title: <Trans i18nKey="common:Matches" />,
      val1: obj1?.nMatches,
      val2: obj2?.nMatches
    },
    {
      title: <Trans i18nKey="common:Innings" />,
      val1: obj1?.nInnings,
      val2: obj2?.nInnings
    },
    {
      title: <Trans i18nKey="common:Runs" />,
      val1: obj1?.nRuns,
      val2: obj2?.nRuns
    },
    {
      title: <Trans i18nKey="common:BallsPlayed" />,
      val1: obj1?.nPlayedBalls,
      val2: obj2?.nPlayedBalls
    },
    {
      title: <Trans i18nKey="common:HighestScore" />,
      val1: obj1?.nHighest,
      val2: obj2?.nHighest
    },
    {
      title: <Trans i18nKey="common:NotOuts" />,
      val1: obj1?.nNotOut,
      val2: obj2?.nNotOut
    },
    {
      title: <Trans i18nKey="common:StrikeRate" />,
      val1: obj1?.sStrikeRate,
      val2: obj2?.sStrikeRate
    },
    {
      title: <Trans i18nKey="common:Average" />,
      val1: obj1?.sAverage,
      val2: obj2?.sAverage
    },
    {
      title: <Trans i18nKey="common:50s" />,
      val1: obj1?.nRun50,
      val2: obj2?.nRun50
    },
    {
      title: <Trans i18nKey="common:100s" />,
      val1: obj1?.nRun100,
      val2: obj2?.nRun100
    },
    {
      title: <><Trans i18nKey="common:4s" />/<Trans i18nKey="common:6s" /></>,
      val1: `${obj1?.nRun4 || '-'}/${obj1?.nRun6 || '-'}`,
      val2: `${obj2?.nRun4 || '-'}/${obj2?.nRun6 || '-'}`
    }
  ]
}

const prepareBowlData = (obj1, obj2) => {
  return [
    {
      title: <Trans i18nKey="common:Matches" />,
      val1: obj1?.nMatches,
      val2: obj2?.nMatches
    },
    {
      title: <Trans i18nKey="common:Innings" />,
      val1: obj1?.nInnings,
      val2: obj2?.nInnings
    },
    {
      title: <Trans i18nKey="common:Overs" />,
      val1: obj1?.sOvers,
      val2: obj2?.sOvers
    },
    {
      title: <Trans i18nKey="common:Runs" />,
      val1: obj1?.nRuns,
      val2: obj2?.nRuns
    },
    {
      title: <Trans i18nKey="common:Wickets" />,
      val1: obj1?.nWickets,
      val2: obj2?.nWickets
    },
    {
      title: <Trans i18nKey="common:BestBowlingInning" />,
      val1: obj1?.sBestBowlingInning,
      val2: obj2?.sBestBowlingInning
    },
    {
      title: <Trans i18nKey="common:BestBowlingMatch" />,
      val1: obj1?.sBestBowlingMatch,
      val2: obj2?.sBestBowlingMatch
    },
    {
      title: <Trans i18nKey="common:Average" />,
      val1: obj1?.sAverage,
      val2: obj2?.sAverage
    },
    {
      title: <Trans i18nKey="common:Economy" />,
      val1: obj1?.sEconomy,
      val2: obj2?.sEconomy
    },
    {
      title: <Trans i18nKey="common:StrikeRate" />,
      val1: obj1?.sStrikeRate,
      val2: obj2?.sStrikeRate
    },
    {
      title: <><Trans i18nKey="common:4W" />/<Trans i18nKey="common:5W" /></>,
      val1: `${obj1?.nWkt4i || '-'}/${obj1?.nWkt5i || '-'}`,
      val2: `${obj2?.nWkt4i || '-'}/${obj2?.nWkt5i || '-'}`
    }
  ]
}

export const preparePlayerStats = (plr1 = [], plr2 = [], selectedFormate) => {
  const p1Stats = plr1?.filter(e => e?.sMatchStatsTypes === selectedFormate?.p1Format?.sMatchStatsTypes)[0]
  const p2Stats = plr2?.filter(e => e?.sMatchStatsTypes === selectedFormate?.p2Format?.sMatchStatsTypes)[0]
  // console.log(p1Stats, p2Stats)
  // const arr = []
  // statsArray?.forEach((val, index) => {
  //   const arrBat = prepareBatData(plr1[val?.nPriority]?.oBatting, plr2[val?.nPriority]?.oBatting)
  //   const arrBowl = prepareBowlData(plr1[val?.nPriority]?.oBowling, plr2[val?.nPriority]?.oBowling)
  //   arr.push({
  //     title: val?.sMatchStatsTypes,
  //     oBatting: arrBat,
  //     oBowling: arrBowl
  //   })
  // })
  return {
    oBatting: prepareBatData(p1Stats?.oBatting, p2Stats?.oBatting),
    oBowling: prepareBowlData(p1Stats?.oBowling, p2Stats?.oBowling)
  }
}
